module.exports = __webpack_public_path__ + "img/poll.ce3181b6.svg";